module.exports = __webpack_public_path__ + "img/shutterstock.28424477.jpg";